import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReadPackagesPriceRangeRequestDto as RequestDto,
  ReadPackagesPriceRangeResponseDto as ResponseDto,
} from "../../api/packages/priceRange/dtos";
import { Api } from "../../api";
import format from "date-fns/format";
import { Activity } from "../../models";
import dinero, { Dinero } from "dinero.js";
import { prepPrice } from "../../../utils";

interface Data {
  [activityId: number]: {
    min: Dinero;
    max: Dinero;
  };
}
interface CallParams {
  activities: Activity[];
  personTypes: { id: number; quantity: number; name: string }[];
  dates: Date[];
}
export const priceRanges = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "ACTIVITIES_PRICE_RANGES",
  Api.activities.readPriceRanges,
  ({ data: { data } }) => {
    return data.reduce(
      (acc, { model_id, max, min }) => ({
        ...acc,
        [model_id]: {
          min: dinero({ amount: prepPrice(min) }),
          max: dinero({ amount: prepPrice(max) }),
        },
      }),
      {}
    );
  },
  ({ activities, personTypes, dates }) => ({
    ids: activities.map(({ id }) => id),
    person_types: personTypes.map(({ id }) => id),
    dates: dates.map((date) => format(date, "yyyy-MM-dd")),
  })
);
